import type { PatchApiV1ThreeLetterCodeClientAdminsClientBody } from '@fukuri-admins/apis/client/gen/model';
import type { EditFormFieldValues } from '../editFormSchema';

type IGeneratePatchRequestBody = (
  formValues: EditFormFieldValues
) => PatchApiV1ThreeLetterCodeClientAdminsClientBody;

/**
 * 送付先住所編集フォームの値から利用企業更新 API のリクエストボディを生成する
 *
 * - employeeCount（テキスト入力の数値文字列）は Number() で employee_count に変換する
 * - prefectureCode（2桁コード文字列）は Number() で prefecture_id に変換する
 *   （都道府県マスタは code のみを返し、更新 API は id を受け取る。code == id の前提は
 *   partner-admin / internal の各 generateRequestBody と同じ）
 * - 全フィールド必須のスキーマを通過した値のみを受け取るため、null 分岐は持たない
 */
export const generatePatchRequestBody: IGeneratePatchRequestBody = formValues => ({
  client: {
    employee_count: Number(formValues.employeeCount),
    shipping_address: {
      postal_code: formValues.postalCode,
      prefecture_id: Number(formValues.prefectureCode),
      city: formValues.city,
      street_address: formValues.streetAddress,
    },
  },
});
